module.exports = __webpack_public_path__ + "73b746d001011ea7ff33c3113f5d6177.svg";